export enum ModalId {
  AddCoApplicant,
  EditCoApplicant,
  SoftPull,
  Account
}

export const ModalPriorities = {
  [ModalId.Account]: 3,
  [ModalId.SoftPull]: 1
};

export enum NativeModalId {
  SoftPull = 'softpull'
}
